var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ajaxSend } from '../../../api/api';
const basePath = '/v1/twitter';
export function getTwitterToken() {
    return ajaxSend({
        path: `${basePath}/request_token`,
    });
}
export function connectTwitterAccount(payload) {
    return ajaxSend({
        method: 'POST',
        path: `${basePath}/accounts/connect`,
        data: payload,
    });
}
export function updateTwitterAccount(twitterId, payload) {
    return ajaxSend({
        method: 'PATCH',
        path: `${basePath}/accounts/${twitterId}`,
        data: payload,
    });
}
export function deleteTwitterAccount(twitterId) {
    return ajaxSend({
        method: 'DELETE',
        path: `${basePath}/accounts/${twitterId}`,
    });
}
export function fetchTwitterAccounts() {
    return __awaiter(this, void 0, void 0, function* () {
        return ajaxSend({
            path: `${basePath}/accounts`,
        });
    });
}
export function getTwitterOrganizationSettings() {
    return __awaiter(this, void 0, void 0, function* () {
        return ajaxSend({
            path: `${basePath}/settings`,
        });
    });
}
